import { RootComponent } from "./components/RootComponent";
import { NotFoundComponent } from "./components/NotFoundComponent";
import { CanvasComponent } from "./components/CanvasComponent";
import { UsernameComponent } from "./components/UsernameComponent";
import { WorldMapComponent } from "./components/WorldmapComponent";
import { StopwatchComponent } from "./components/StopwatchComponent";
import { CablePuzzleComponent } from "./components/CablePuzzleComponent";
import { CablePuzzlePageComponent } from "./components/CablePuzzlePageComponent";
import { CablePuzzleModal } from "./components/CablePuzzleModal";
import { InstructionComponent } from "./components/InstructionComponent";
import { InventoryComponent } from "./components/InventoryComponent";
import { HighscoreComponent } from "./components/HighscoreComponent";
import { QuestComponent } from "./components/QuestComponents";

window.customElements.define("game-root", RootComponent as CustomElementConstructor);
window.customElements.define("game-notfound", NotFoundComponent as CustomElementConstructor);
window.customElements.define("game-canvas", CanvasComponent as CustomElementConstructor);
window.customElements.define("world-map", WorldMapComponent as CustomElementConstructor);
window.customElements.define("game-stopwatch", StopwatchComponent as CustomElementConstructor);
window.customElements.define("game-info", InstructionComponent as CustomElementConstructor);
window.customElements.define("game-username", UsernameComponent as CustomElementConstructor);
window.customElements.define("game-inventory", InventoryComponent as CustomElementConstructor);
window.customElements.define("cable-puzzle", CablePuzzleComponent as CustomElementConstructor);
window.customElements.define("cable-puzzle-page", CablePuzzlePageComponent as CustomElementConstructor);
window.customElements.define("game-highscore", HighscoreComponent as CustomElementConstructor);
window.customElements.define("quest-objectives", QuestComponent as CustomElementConstructor);

new CablePuzzleModal();
